<div class="banqi-container" *ngIf="show">
  <h2>Você conhece o banQi?</h2>

  <div class="banqi-logo">
  </div>

  <div class="banqi-content">
    <p class="app-banqi-text">
      Você pode acompanhar os pagamentos do seu carnê e realizar outras operações através do app banQi, a conta digital da Casas Bahia.
    </p>

    
    <a 
      *ngIf="!(isMinorThanTablet | async).matches"
      class="app-banqi"
      data-context="renegociacao" 
      data-collect="play store" 
      href='https://banqi.onelink.me/oJyK/24083965'
      target="_blank">
      <img class="banner-download-banqi" src="assets/images/banners/banqi/desktop/banner-banqi-boleto.svg" alt="Baixe agora o app de graça">
    </a>
    
    <a 
      *ngIf="(isMinorThanTablet | async).matches"
      class="app-banqi"
      data-context="renegociacao" 
      data-collect="play store" 
      href='https://banqi.onelink.me/oJyK/24083965'
      target="_blank">
      <img class="banner-download-banqi" src="assets/images/banners/banqi/mobile/banner-banqi-boleto-mobile.svg" alt="Baixe agora o app de graça">
    </a>
  </div>
</div>